import * as svg from "../../../assets/refresh.svg";

import {iconBuilder} from "./iconBuilder";

const RefreshIcon = iconBuilder(svg, "RefreshIcon", "0 0 16 16");

export default RefreshIcon;
